import * as React from "react";
import { Icon } from "sb-resp-ui";
export class Place extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-current-races__place" },
            React.createElement("div", { className: "rj-racing-current-races__league" }, this.props.label),
            this.props.hasLiveStream && (React.createElement("div", { className: "rj-racing-current-races__right-panel" },
                React.createElement(Icon, { i: "i-24-16 i-o-ev-streaming" })))));
    }
}
//# sourceMappingURL=Place.js.map